
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ISortParameters, ITransaction, IWallet } from "@/interfaces";
import TransactionService from "@/services/transaction";
import { CoreTransaction, MagistrateTransaction, TypeGroupTransaction } from "@/enums";

@Component({
  computed: {
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class WalletTransactions extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private transactions: ITransaction[] | null = null;
  private receivedCount = 0;
  private sentCount = 0;
  private locksCount = 0;
  private meta: any | null = null;
  private smartbridgeFilter: string;

  get isTypeSent() {
    return this.type === "sent";
  }

  get isTypeReceived() {
    return this.type === "received";
  }

  get isTypeLocks() {
    return this.type === "locks";
  }

  get type() {
    return this.$store.getters["ui/walletTransactionTab"];
  }

  set type(type: string) {
    this.$store.dispatch("ui/setWalletTransactionTab", type);
  }

  get hasHtlcEnabled() {
    return this.$store.getters["network/hasHtlcEnabled"];
  }

  get sortParams() {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  @Watch("wallet")
  public onWalletChanged() {
    this.getTransactions();

    this.getSentCount();
    this.getReceivedCount();
    this.getLocksCount();
  }

  @Watch("smartbridgeFilter")
  public onSmartbridgeFilterChanged() {
    if (this.smartbridgeFilter !== "hidden") {
      this.getTransactions();
    }
  }

  public mounted() {
    this.getTransactions();

    this.getSentCount();
    this.getReceivedCount();
    this.getLocksCount();
  }

  private async getTransactions() {
    this.transactions = null;

    if (this.wallet.address !== undefined) {
      // @ts-ignore
      const { data, meta } = await TransactionService[`${this.type}ByAddress`](this.wallet.address, 1);

      // Only need to check for sent / received transactions
      if (!this.isTypeLocks) {
        // TODO: move to separate function
        const lockIds: string[] = [];
        let transactions = data.map((transaction: ITransaction) => {
          // @ts-ignore
          if (this.isTimelock(transaction.type, transaction.typeGroup)) {
            lockIds.push(transaction.id);
          }
          return { ...transaction, price: null };
        });
        if (lockIds.length > 0) {
          const response = await TransactionService.findUnlockedForLocks(lockIds);
          const locksHash: { [key: string]: number } = {};

          // Fetch the corresponding timelock id for the claim / refund transactions
          for (const lockTransaction of response.data) {
            if (lockTransaction.type === CoreTransaction.TIMELOCK_REFUND) {
              locksHash[lockTransaction.asset.refund.lockTransactionId] = 10;
            } else {
              locksHash[lockTransaction.asset.claim.lockTransactionId] = 9;
            }
          }

          // Set an additional property on the locks that got claimed / refunded
          transactions = transactions.map((transaction: ITransaction) => {
            if (locksHash[transaction.id]) {
              return { ...transaction, lockStatus: locksHash[transaction.id] };
            }
            return transaction;
          });
        }
        this.transactions = transactions;
        this.meta = meta;
        return;
      } else {
        this.transactions = data.map((transaction: ITransaction) => ({ ...transaction, price: null }));
      }
    }
  }

  private async getCountByType(type: string) {
    if (this.wallet && this.wallet.address) {
      try {
        const response = await TransactionService[`${type}ByAddressCount`](this.wallet.address);
        this[`${type}Count`] = response;
      } catch (error) {
        this[`${type}Count`] = 0;
      }
    }
  }

  private getReceivedCount() {
    this.getCountByType("received");
  }

  private getSentCount() {
    this.getCountByType("sent");
  }

  private getLocksCount() {
    this.getCountByType("locks");
  }

  private setType(type: string) {
    this.type = type;

    this.getTransactions();
  }

  private onSortChange(params: ISortParameters) {
    this.sortParams = params;
  }
}
